import {
  APP_STARTUP,
  APP_STARTUP_SUCCESS,
  APP_STARTUP_FAILURE,
  APP_LOGIN_SUCCESS,
  APP_LOGIN_FAILURE
} from "../../store/constants/general";

const initialState = {
  isLoaded: false,
  isLoading: false,
  isWired: false,
  error: false,
  errorDescription: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case APP_STARTUP:
      return {
        ...state,
        isLoading: true
      };
    case APP_STARTUP_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        isLoading: false
      };
    case APP_STARTUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorDescription: action.error
      };
    case APP_LOGIN_SUCCESS:
      return {
        ...state,
        isWired: true
      };
    case APP_LOGIN_FAILURE:
      return {
        ...state,
        isWired: false
      };
    default:
      return state;
  }
}
